import request from '@/utils/request'

const http = request()

export const listPrj = params => http.post('/project/other/page', params)

export const savePrj = params => http.raw(params.nextStep ? '/project/other/submit' : '/project/other/save', params)

export const viewPrj = (projectId, isDetail = false) => (isDetail ? http.post('/project/other/detail', { projectId }) : http.post('/project/other/view', { projectId }))

export const updatePrj = params => http.raw('/project/other/update', params)

export const getBudgets = projectId => http.post('/project/other/budgets', { projectId })

export const stopPrj = projectId => http.post('/project/other/stop', { projectId })

export const concludePrj = projectId => http.post('/project/other/conclude', { projectId })

export const closePrj = projectId => http.post('/project/other/close', { projectId })

export const deletePrj = projectId => http.post('/project/other/delete', { projectId })

export const backwardPrj = projectId => http.post('/project/other/backward', { projectId })
